import { cn } from '@/lib/utils'

/**
 * Shared page width for Salon Desk — uses full width up to 1440px (no narrow column).
 *
 * @param {{
 *   title: string,
 *   description?: string,
 *   children: import('react').ReactNode,
 *   className?: string,
 * }} props
 */
export function SalonPageShell({ title, description, children, className }) {
  return (
    <div className={cn('salon-page', className)}>
      <header className="mb-6 sm:mb-8">
        <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">{title}</h1>
        {description ? (
          <p className="mt-2 max-w-3xl text-base text-muted-foreground">{description}</p>
        ) : null}
      </header>
      {children}
    </div>
  )
}
